<template>
  <div
    id="register-view"
    class="form-container position-absolute top-50 start-50 translate-middle"
  >
    <!-- ------------ -->
    <!--    header    -->
    <!-- ------------ -->
    <div class="outer-area">
      <div class="auth-box text-center">
        <img
          class="mt-4"
          src="/bbLogo32Blue.png"
          alt="logo"
        />
        <p class="fw-lighter mt-4 mb-5 bb-app-heading">BATTLEBOARD</p>
        <!-- ------------ -->
        <!--   message    -->
        <!-- ------------ -->
        <MessageCardComponent
          v-show="showRegisterMessage"
          :message="statusMessage"
        />
        <!-- ------------ -->
        <!--    form      -->
        <!-- ------------ -->
        <div>
          <form
            @submit.prevent="register"
            autocomplete="off"
          >
            <div class="form-group">
              <!-- ------------ -->
              <!--     email    -->
              <!-- ------------ -->
              <div class="form-group">
                <div class="form-floating mb-3">
                  <input
                    v-model="email"
                    v-bind:class="{
                      'is-invalid': errorFields.includes('email'),
                    }"
                    type="text"
                    onkeyup="this.value = this.value.toLowerCase();"
                    name="email"
                    id="floatingEmail"
                    placeholder="email"
                    class="form-control"
                    autocomplete="off"
                    required
                  />
                  <label
                    class="bb-float-label"
                    for="floatingEmail"
                    >Email</label
                  >
                </div>
              </div>
              <!-- ------------------ -->
              <!--    passwords       -->
              <!-- ------------------ -->
              <div class="row g-2 register-two-col">
                <div class="col-sm-6">
                  <div class="form-floating password mb-3">
                    <input
                      v-model="password1"
                      v-bind:class="{
                        'is-invalid': errorFields.includes('password1'),
                      }"
                      name="password1"
                      class="form-control"
                      placeholder="password"
                      :type="fieldTypes.password"
                      id="password1"
                      autocomplete="new-password"
                      required
                    />
                    <label
                      class="bb-float-label"
                      for="password1"
                      >Password</label
                    >
                    <div class="input-group-addon">
                      <i
                        class="bi bi-eye-slash"
                        id="togglePassword1"
                      ></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-floating password mb-3">
                    <input
                      v-model="password2"
                      v-bind:class="{
                        'is-invalid': errorFields.includes('password2'),
                      }"
                      name="password2"
                      class="form-control"
                      placeholder="repeat password"
                      :type="fieldTypes.password"
                      autocomplete="new-password"
                      id="password2"
                      required
                    />
                    <label
                      class="bb-float-label"
                      for="password2"
                    >
                      Repeat Password</label
                    >
                    <div class="input-group-addon">
                      <i
                        class="bi bi-eye-slash"
                        id="togglePassword2"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              <!-- -------------- -->
              <!--   names        -->
              <!-- -------------- -->
              <div class="row g-2 register-two-col">
                <div class="col-sm-6">
                  <div class="form-floating mt-3 mb-3">
                    <input
                      v-model="first_name"
                      v-bind:class="{
                        'is-invalid': errorFields.includes('first_name'),
                      }"
                      name="first_name"
                      id="first_name"
                      placeholder="first name"
                      type="text"
                      class="form-control capitalize"
                      autocomplete="off"
                      required
                    />
                    <label
                      class="bb-float-label"
                      for="first_name"
                      >First Name</label
                    >
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-floating mt-3 mb-3">
                    <input
                      v-model="last_name"
                      v-bind:class="{
                        'is-invalid': errorFields.includes('last_name'),
                      }"
                      name="last_name"
                      id="last_name"
                      placeholder="last name"
                      type="text"
                      class="form-control capitalize"
                      autocomplete="off"
                      required
                    />
                    <label
                      class="bb-float-label"
                      for="last_name"
                      >Last Name</label
                    >
                  </div>
                </div>
              </div>
              <!-- -------------- -->
              <!--   user name    -->
              <!-- -------------- -->
              <div class="form-group">
                <div class="form-floating mt-3 mb-3">
                  <input
                    v-model="user_name"
                    v-bind:class="{
                      'is-invalid': errorFields.includes('user_name'),
                    }"
                    name="user_name"
                    id="user_name"
                    placeholder="username"
                    type="text"
                    class="form-control capitalize"
                    autocomplete="off"
                    required
                  />
                  <label
                    class="bb-float-label"
                    for="user_name"
                    >Username</label
                  >
                </div>
              </div>
            </div>
            <!-- ------------ -->
            <!--    errors    -->
            <!-- ------------ -->
            <div
              v-for="err in errors"
              :key="err"
              class="bb-error-wrap mt-2 mb-2"
            >
              {{ err }}
            </div>
            <!-- ------------ -->
            <!--    submit    -->
            <!-- ------------ -->
            <div class="register-submit-row">
              <button
                type="submit"
                :disabled="isSubmitDisabled"
                class="btn btn-lg btn-primary mt-3 mb-3"
              >
                Register
              </button>
            </div>
          </form>
        </div>
        <!-- ------------------ -->
        <!--        login       -->
        <!-- ------------------ -->
        <div class="bb-vert-text-divider">
          <router-link
            class="bb-link"
            to="/login"
            >Login</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import MessageCardComponent from '@/views/MessageView.vue'
//----------------------
// scripts
//----------------------
export default {
  name: 'registerView',
  //----------------------
  // components
  //----------------------
  components: {
    MessageCardComponent,
  },
  //----------------------
  // data
  //----------------------
  data() {
    return {
      email: '',
      invite_token: '',
      first_name: '',
      last_name: '',
      user_name: '',
      password1: '',
      password2: '',
      fieldTypes: {
        password: 'password',
      },
      errors: [],
      errorFields: [],
    }
  },
  //----------------------
  // computed
  //----------------------
  computed: {
    ...mapGetters('auth', {
      getRegisterStatus: 'getRegisterStatus',
    }),
    ...mapGetters('auth', {
      isRegisterOpen: 'isRegisterOpen',
    }),
    ...mapGetters('auth', {
      signupMode: 'getSignupMode',
    }),
    isInviteOnly() {
      return this.signupMode === 'invite_only'
    },
    hasInviteToken() {
      return Boolean(this.invite_token)
    },
    canRegister() {
      if (this.isRegisterOpen) {
        return true
      }
      return this.isInviteOnly && this.hasInviteToken
    },
    showRegisterMessage() {
      return !this.canRegister && Boolean(this.statusMessage)
    },
    isSubmitDisabled() {
      return !this.canRegister || !this.isReady
    },
    statusMessage() {
      if (this.isInviteOnly && this.hasInviteToken) {
        return 'Invitation token detected. Complete the form to finish registration.'
      }
      return this.getRegisterStatus
    },
    isReady() {
      if (
        this.email &&
        this.password1 &&
        this.password2 &&
        this.first_name &&
        this.last_name &&
        this.user_name
      ) {
        return true
      }
      return false
    },
  },
  //----------------------
  // methods
  //----------------------
  methods: {
    ...mapActions('auth', {
      verifyRegisterOpen: 'verifyRegisterOpen',
    }),
    ...mapActions('auth', {
      registerUser: 'registerUser',
    }),
    ...mapMutations('auth', {
      setMessage: 'setMessage',
    }),
    //-----------------------------
    // check register open method
    //-----------------------------
    async checkRegisterOpen() {
      //----------------------
      // api call
      //----------------------
      await this.verifyRegisterOpen()
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          let error = window.bbErrorMsg(err)
          this.errors.push(error)
        })
    },
    //----------------------
    // register method
    //----------------------
    async register() {
      if (this.isSubmitDisabled) {
        return
      }

      this.errors = []
      this.errorFields = []
      const payload = {
        email: this.email,
        password1: this.password1,
        password2: this.password2,
        first_name: this.first_name,
        last_name: this.last_name,
        user_name: this.user_name,
      }
      if (this.invite_token) {
        payload.invite_token = this.invite_token
      }
      //----------------------
      // api call
      //----------------------
      await this.registerUser(payload)
        //-----------------------------------
        // where successful (force re-logon)
        //-----------------------------------
        .then(() => {
          const message =
            'Account registered successfully.\n' +
            '\nPlease log in using your new account details.'

          this.setMessage(message)
          this.$router.push({
            name: 'loginView',
            query: { email: this.email },
          })
        })
        //----------------------
        // where error
        //----------------------
        .catch((err) => {
          this.errors.push(window.bbErrorMsg(err))
          this.errorFields.push(window.bbErrorKey(err))
        })
    },
  },
  //-------------------------
  // mounted
  //-------------------------
  mounted() {
    //-------------------------
    // set background colour
    //-------------------------
    document.body.className = 'bb-bg-partial'

    var cond = document.getElementById('togglePassword1')
    if (typeof cond !== 'undefined' && cond !== null) {
      //---------------------------------
      // toggle password display (setup)
      //---------------------------------
      const togglePassword1 = document.querySelector('#togglePassword1')
      const password1 = document.querySelector('#password1')
      togglePassword1.addEventListener(
        'click',
        togglePassword.bind(null, togglePassword1, password1),
        false,
      )

      const togglePassword2 = document.querySelector('#togglePassword2')
      const password2 = document.querySelector('#password2')
      togglePassword2.addEventListener(
        'click',
        togglePassword.bind(null, togglePassword2, password2),
        false,
      )
    }
    //------------------------------------
    // toggle password display (function)
    //------------------------------------
    function togglePassword(eye, el) {
      const type = el.getAttribute('type') === 'password' ? 'text' : 'password'
      el.setAttribute('type', type)
      eye.classList.toggle('bi-eye')
    }
  },
  //-------------------------
  // unmounted
  //-------------------------
  unmounted() {
    document.body.className = 'bb-bg-full'
  },
  //-----------------------------------
  // on creation - check register open
  //-----------------------------------
  created() {
    this.invite_token = String(this.$route.query.invite || '').trim()
    const invitedEmail = String(this.$route.query.email || '').trim()
    if (invitedEmail) {
      this.email = invitedEmail.toLowerCase()
    }
    this.checkRegisterOpen()
  },
}
</script>
